<template>
  <div>
    <el-divider>{{$t('私有属性')}}</el-divider>
    <el-form-item :label="$t('默认值')">
      <el-input v-model="data.default"
                :placeholder="$t('请输入')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('前缀')">
      <el-input v-model="data.prepend"
                :placeholder="$t('前缀')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('后缀')">
      <el-input v-model="data.append"
                :placeholder="$t('后缀')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('前图标')">
        <l-input-icon onlyFirst v-model="data.prefixIcon" >
        </l-input-icon>
    </el-form-item>
    <el-form-item :label="$t('后图标')">
        <l-input-icon onlyFirst v-model="data.suffixIcon" >
        </l-input-icon>
    </el-form-item>
     
    <el-form-item :label="$t('最大长度')">
      <el-input-number v-model="data.maxlength"
                       controls-position="right"
                       :placeholder="$t('请输入')"></el-input-number>
    </el-form-item>
    <!-- <el-form-item :label="$t('是否可见')">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item> -->
    <el-form-item :label="$t('是否只读')">
      <el-switch v-model="data.readonly"></el-switch>
    </el-form-item>
    <div class="mt-8">
        <el-button
            class="ml-8"
            type="primary"
            size="mini"
            @click="handleSettingEvent(data)"
            >设置脚本</el-button
        >
    </div>
    <el-divider>{{$t('校验')}}</el-divider>
    <el-form-item :label="$t('是否必填')">
      <el-switch v-model="data.required" ></el-switch>
    </el-form-item>
    <div class="reg-item" :key="index" v-for="(item,index) in data.patterns" >
        <el-form-item :label="$t('表达式')">
            <el-input v-model="item.reg"
                    :placeholder="$t('请输入')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('错误提示')" style="margin-bottom:0;" >
            <el-input v-model="item.msg"
                    :placeholder="$t('请输入')"></el-input>
        </el-form-item>
        <el-button :title="$t('删除')"
                    @click="handleRemovePatterns(index)"
                    class="reg-item-delete"
                    circle
                    plain
                    size="mini"
                    type="danger">
            <i class="el-icon-close"></i>
        </el-button>
    </div>
    <div class="mt-8" >
        <el-dropdown @command="handleValidatorSelect" >
            <el-button type="primary" size="mini" >
                {{$t('添加常用校验')}}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown"  >
                <el-dropdown-item :key="item.name" :command="item" v-for="item in validatorRules" >{{item.name}}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <el-button class="ml-8" type="primary" size="mini" @click="handleCustmerReg"  >{{$t('自定义规则')}}</el-button>
    </div>
    <l-dialog 
        :title="$t('卡片点击事件脚本')"
        :visible.sync="jsVisible"
        :height="528"
        :width="1000"
        @ok="handleCodeSave"
        >
        <l-layout :right="320">
            <l-code-mirror v-model="scenario" mode="application/javascript"></l-code-mirror>
            <template #right>
                <div class="l-rblock" style="padding:8px;overflow: auto;" >
                    <el-alert
                        title=""
                        type="info"
                        :closable="false"
                        >
                        let {getComponent, component} = params<br/>
                        getComponent 操作组件；传组件ID<br/>
                        changeQueryData, 做组件查询操作；传查询参数<br/>
                    </el-alert>
                </div>
                
            </template>
        </l-layout>
    </l-dialog>
  </div>
</template>

<script>

export default {
    name: "config-input",
    props: ['data'],
    data () {
        return {
            scenario: '',
            jsVisible:false
        }
    },
    computed: {
        validatorRules(){
            if(this.lr_validatorRules){
              return this.lr_validatorRules
            }
            else{
              return []
            }
        }
    },
    methods: {
        handleCodeSave(){
            if (!this.scenario) {
                this.data.scenario = ''
                this.jsVisible = false
                return
            }
            const {res,msg} = this.getEvent(this.scenario)
            if(res){
                this.data.scenario = this.scenario
                this.jsVisible = false
            }
            else{
                this.$message({
                    type: 'error',
                    message: `脚本错误:${msg}`
                })
            }
        },
        getEvent(strEvent) {
            // 获取事件方法
            if (!this.$validatenull(strEvent)) {
            strEvent = `async (params) => {${strEvent}}`;
            return this.$getFunction(strEvent);
            } else {
            return { res: false, msg: "没设置脚本函数！" };
            }
        },
        handleSettingEvent(){
            this.scenario = this.data.scenario;
            this.jsVisible = true;
        },
        handleValidatorSelect(val){
            this.data.patterns.push({
                msg:`${this.$t('请输入')}${val.name}`,
                reg:val.reg
            })
        },
        handleCustmerReg(){
            this.data.patterns.push({
                msg:'',
                reg:''
            })
        },
        handleRemovePatterns(index){
            this.data.patterns.splice(index,1)
        }
    }
}
</script>

